<template>
	<footer class="zui-footer">
		<cms-column id="555" class="links" @loaded="columnLoaded">
			<template slot-scope="{data}">
				<div class="erweima">
					<div class="top">
						<logo type="footer1" class="footer-img" href="/" :name="'世界自然遗产'"></logo>
						<logo type="footer3" class="footer-img" href="/" :name="'国家AAAAA级旅游区'"></logo>
						<logo type="footer4" class="footer-img" href="/" :name="'中国国家风景名胜区'"></logo>
						<logo type="footer2" class="footer-img" href="/" :name="'梅丽娜、迈乐库里世界文化景观'"></logo>
						<logo type="footer5" class="footer-img" href="/" :name="'全球优秀生态景区'"></logo>
					</div>
					<div class="flex-footer flex-footer_out">
						<div class="left" style="position: relative;top: -5px;">
							<div class="text">
								友情链接
							</div>
							<div class="flex-footer">
								<div class="link w48"><a href="https://emsjq.leshan.gov.cn/" target="_blank">峨眉山景区政务网</a>
								</div>
								<div class="link w48"><a href="http://www.emsfj.com/" target="_blank">峨眉山景区佛教网</a></div>
							</div>
							<div class="flex-footer-single">
								<!--<el-select v-model="value" placeholder="峨眉山旅游股份有限公司官网">
                                    <el-option
                                            v-for="item in linkList"
                                            :key="item.id"
                                            :label="item.title"
                                            :value="item.id">
                                    </el-option>
                                </el-select>-->
								<el-menu mode="horizontal" background-color="#000000" text-color="#cecece"
										 active-text-color="#cecece" @select="linkSelect" menu-trigger="click">
									<el-submenu index="2">
										<template slot="title">
											<div class="link">{{ linkObject.name }}</div>
											<em class="el-icon-caret-top"></em>
										</template>
										<el-menu-item :class="isMobile?'el-menu-item-mobile':''" :index="item.id"
													  v-for="item in linkList" :key="item.id">{{ item.title }}</el-menu-item>
									</el-submenu>
								</el-menu>
							</div>
							<div class="text">
								友好景区
							</div>
							<div class="flex-footer-single">
								<!--<el-select v-model="value" placeholder="峨眉山旅游股份有限公司官网">
                                    <el-option
                                            v-for="item in linkList"
                                            :key="item.id"
                                            :label="item.title"
                                            :value="item.id">
                                    </el-option>
                                </el-select>-->
								<el-menu mode="horizontal" background-color="#000000" text-color="#cecece"
										 active-text-color="#cecece" @select="friendSelect" menu-trigger="click">
									<el-submenu index="2">
										<template slot="title">
											<div class="link">{{ friendObject.name }}</div>
											<em class="el-icon-caret-top"></em>
										</template>
										<el-menu-item :class="isMobile?'el-menu-item-mobile':''" :index="item.id"
													  v-for="item in friendList" :key="item.id">{{ item.title }}</el-menu-item>
									</el-submenu>
								</el-menu>
							</div>
						</div>
						<div class="middle flex-footer">
							<div class="erweima-item">
								<el-popover
										placement="top"
										trigger="hover">
									<img src="./img/footerlogo1.jpg" alt="" style="width: 200px">
									<logo type="footerlogo1" class="footer-logo" href="/" slot="reference"></logo>
								</el-popover>
								<div class="logo-text">峨眉山景区 <br>微信公众号</div>
							</div>
							<div class="erweima-item">
								<el-popover
										placement="top"
										trigger="hover">
									<img src="./img/footerlogo2.jpg" alt="" style="width: 200px">
									<logo type="footerlogo2" class="footer-logo" href="/" slot="reference"></logo>
								</el-popover>
								<div class="logo-text">识途旅游网 <br>微信公众号</div>
							</div>
							<div class="erweima-item">
								<el-popover
										placement="top"
										trigger="hover">
									<img src="./img/footerlogo3.png" alt="" style="width: 200px">
									<logo type="footerlogo3" class="footer-logo" href="/" slot="reference"></logo>
								</el-popover>
								<div class="logo-text">峨眉山景区 <br>抖音官方账号</div>
							</div>
						</div>
						<div class="right">
							<div class="top_cn">
								<div class="phone"></div>
								<div>
									<div>全国统一服务热线</div>
									<div style="font-size: 24px;font-weight: bold;margin-top: 10px" @click="phoneCall( data.ext1value )">{{ data.ext1value }}</div>
								</div>
								<div class="weibo-icon">
									<div class="weibo" @click="weiboClick(data)"></div>
									<span class="weibo-text">微博</span>
								</div>
							</div>
							<div class="bottom">
								<a href="/new/aboutus" target="_blank">关于我们</a>
								<a @click="touristsClick">游玩须知</a>
								<a href="/new/visitor/question" target="_blank">常见问题</a>
							</div>
						</div>
					</div>
				</div>
				<div class="contact">
					<!-- <div class="yellowText"><a href="http://www.ems517.com/old" target="_blank">本网站为峨眉山旅游网测试版　　　　　点此可前往原峨眉山旅游网</a></div> -->
					<p class="copy-right" v-for="(item, index) in copyrightList" :key="index">
						<a href="https://beian.miit.gov.cn" target="_blank" v-if="index === 2">{{ item }}</a>
						<span v-else>{{ item }}</span>

					</p>
				</div>
			</template>
		</cms-column>
	</footer>
</template>
<script>
/** @format */

import './less/footer.css';
import Logo from './Logo';
import { getArticles } from '../api/CmsApi';
export default {
    components: {
        Logo,
    },
    data() {
        return {
            copyrightList: [],
            linkList: [],
            friendList: [],
            isMobile: false,
            linkObject: {
                name: '',
                index: '',
                children: [],
            },
			friendObject: {
                name: '',
                index: '',
                children: [],
            },
        };
    },
    mounted() {
        this.getLinkList();
        this.geFriendList();
        if (document.getElementsByClassName('zui-page')[0].getAttribute('class').includes('mobileClass')) {
            this.isMobile = true;
        }
    },
    methods: {
        //判断是移动端 然后拨打电话
        phoneCall(phone) {
            let userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes('mobile')) {
                let a = document.createElement('a'); // 创建a标签
                a.setAttribute('href', `tel:${phone}`); // 设置href属性为打电话
                a.setAttribute('id', 'telMedicine'); // 设置a标签的id属性，这里一定要注意 别添加_blank属性，加了在手机上无法拨打电话。
                // 删除已有的a标签， 防止反复添加a标签
                if (document.getElementById('telMedicine')) {
                    document.body.removeChild(document.getElementById('telMedicine'));
                }
                document.body.appendChild(a); // 将a标签添加到页面上
                a.click();
            }
        },
        weiboClick(data) {
            window.open(data.ext2value);
        },
        columnLoaded(data) {
            if (data.note) {
                this.copyrightList = data.note.split(/\n/);
            }
        },
        touristsClick() {
            if (this.$route.path === '/visitor') {
                // document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.$emit("toTop")
            } else {
                this.$openNewWindow('/new/visitor?tourists=1');
            }
        },
        getLinkList() {
            // 获取友情链接下拉选
            getArticles({
                page: 1,
                limit: 99,
                cateId: '99',
            }).then(res => {
                const list = res.data.records || [];
                if (list.length > 0) {
                    this.$set(this.linkObject, 'name', list[0].title);
                    this.$set(this.linkObject, 'index', list[0].id);
                }
                this.linkList = list;
            });
        },
        geFriendList() {
            // 获取友情链接下拉选
            getArticles({
                page: 1,
                limit: 99,
                cateId: '111',
            }).then(res => {
                const list = res.data.records || [];
                if (list.length > 0) {
                    this.$set(this.friendObject, 'name', list[0].title);
                    this.$set(this.friendObject, 'index', list[0].id);
                }
                this.friendList = list;
            });
        },
        linkSelect(key) {
            const link = this.linkList.find(a => a.id === key);
            if(link.ext1){//有链接跳链接
				window.open(link.ext1,'_blank');
			}else{

				//无链接打开公众号二维码
            	this.showPicture(link.imgs)
			}
        },
		friendSelect(key) {
            const link = this.friendList.find(a => a.id === key);
            if(link.ext1){//有链接跳链接
				window.open(link.ext1,'_blank');
			}else{
				//无链接打开公众号二维码
            	this.showPicture(link.imgs)
			}
        },
		//点击查看大图
		showPicture(src) {
			this.$viewerApi({
				images: src ? [src] : this.images,
				options: {
					inline: false,
					button: true,
					navbar: false,
					title: false,
					toolbar: false,
					tooltip: false,
					movable: false,
					zoomable: false,
					rotatable: false,
					scalable: false,
					transition: false,
					fullscreen: true,
					keyboard: true,
				}
			})
		},
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue